import type { SuggestionTrailerAvailability } from '@chukua/common';

/** Where the crew's trailer is now, in a few words. Only a trailer on another truck needs action (the crew's warning says so), so only it is flagged. */
export function trailerAvailabilityLabel({ state, coupledTruckRegistration }: SuggestionTrailerAvailability): { text: string; needsSwap: boolean } {
  if (state === 'on_another_truck') return { text: `on ${coupledTruckRegistration}`, needsSwap: true };
  if (state === 'on_this_truck') return { text: 'coupled to this truck', needsSwap: false };
  return { text: 'parked', needsSwap: false };
}
